import React from "react";
import { CellTower, MoreVert, CalendarToday } from "@mui/icons-material";

const styles = {
  card: {
    background: "#FFFFFF",
    borderRadius: "12px",
    padding: "16px 16px 12px 16px",
    width: "320px",
    height: "fit-content",
    color: "white",
    fontFamily: "system-ui, -apple-system, sans-serif",
    border: "1px solid rgba(30, 58, 138, 0.3)",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
    transition: "all 0.3s ease",
    cursor: "pointer",
    boxSizing: "border-box",
    overflow: "hidden",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "12px",
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  title: {
    fontSize: "16px",
    fontWeight: "500",
    margin: 0,
    color: "#1F1C45",
    transition: "color 0.3s ease",
  },
  towerIcon: {
    width: "20px",
    height: "20px",
    color: "#2989CF",
    transition: "transform 0.3s ease, color 0.3s ease",
  },
  menuButton: {
    background: "none",
    border: "none",
    color: "#1F1C45",
    cursor: "pointer",
    padding: "4px",
    borderRadius: "4px",
    transition: "all 0.3s ease",
  },
  divider: {
    border: "none",
    borderTop: "1px solid #E5E7EB",
    margin: "8px 0 12px 0",
  },
  content: {
    marginBottom: "12px",
  },
  contentItem: {
    color: "#1F1C45",
    marginBottom: "8px",
    fontSize: "13px",
    lineHeight: "1.5",
    transition: "transform 0.2s ease",
  },
  contentLabel: {
    fontWeight: 400,
    fontFamily: "Inter, sans-serif",
  },
  contentValue: {
    fontSize: "14px",
    fontWeight: 550,
    fontFamily: "Inter, sans-serif",
  },
  footer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  dateContainer: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    color: "#1F1C45",
    transition: "transform 0.2s ease",
  },
  calendarIcon: {
    width: "16px",
    height: "16px",
    color: "#2989CF",
    transition: "transform 0.3s ease",
  },
  dateText: {
    fontSize: "13px",
    color: "#1F1C45",
    fontFamily: "Inter, sans-serif",
  },
  detectButton: {
    backgroundColor: "#ffffff",
    border: "1.5px solid #2989CF",
    color: "#333333",
    borderRadius: "6px",
    fontSize: "14px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    height: "30px",
    fontWeight: "500",
    position: "relative",
    overflow: "hidden",
    paddingLeft: "20px",
    paddingRight: "20px",
  },
};

export function TowerCard({
  title,
  date,
  info = [], 
  footerButtonText ,
  footerButtonDisabled = false,
  footerButtonOnClick,
  onClick,
}) {
  return (
    <div style={styles.card} onClick={onClick}>
      {/* Header */}
      <div style={styles.header}>
        <div style={styles.headerLeft}>
          <CellTower style={styles.towerIcon} />
          <h3 style={styles.title}>{title}</h3>
        </div>
        {/* <button style={styles.menuButton}>
          <MoreVert style={{ width: "20px", height: "20px" }} />
        </button> */}
      </div>

      <hr style={styles.divider} />

      {/* Content */}
      <div style={styles.content}>
        {info.map((item, idx) => (
          <div key={idx} style={styles.contentItem}>
            <span style={styles.contentLabel}>{item.label} </span>
            <span style={styles.contentValue}>{item.value}</span>
          </div>
        ))}
      </div>

      <hr style={styles.divider} />

      {/* Footer */}
      <div style={styles.footer}>
        <div style={styles.dateContainer}>
          <CalendarToday style={styles.calendarIcon} />
          <span style={styles.dateText}>{date}</span>
        </div>
     {footerButtonText &&
        <button
          onClick={(e) => {
            e.stopPropagation();
            footerButtonOnClick();
          }}
          style={{
            ...styles.detectButton,
            cursor: footerButtonDisabled ? "not-allowed" : "pointer",
            background: footerButtonDisabled ? "#d3d3d3" : "#ffffff",
            opacity: footerButtonDisabled ? 0.6 : 1,
          }}
          disabled={footerButtonDisabled}
        >
          {footerButtonText}
        </button>
        }
      </div>
    </div>
  );
}
